import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiPaginationResponse, ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  CreateCompanyPayload,
  CreateCompanyRelationPayload,
  FetchCompaniesPayload,
  GetCompanyPayload,
  ICompany,
  ISingleCompany,
  RemoveCompanyPayload,
  RemoveCompanyRelationPayload,
  UpdateCompanyPayload,
  UpdateCompanyRelationPayload,
} from '../types/companies.types';

export const companiesApi = createApi({
  reducerPath: 'companiesApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/companies`),
  endpoints: (builder) => ({
    removeCompany: builder.mutation<ApiResponse<any>, RemoveCompanyPayload>({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: 'DELETE',
      }),
    }),
    fetchCompanies: builder.query<ApiPaginationResponse<ICompany[]>, FetchCompaniesPayload>({
      query: (params) => ({
        url: '',
        method: 'GET',
        params,
      }),
    }),
    getCompany: builder.query<ApiResponse<ISingleCompany>, GetCompanyPayload>({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: 'GET',
      }),
    }),
    createCompany: builder.mutation<ApiResponse<ISingleCompany>, CreateCompanyPayload>({
      query: (payload) => ({
        url: '',
        method: 'POST',
        body: payload,
      }),
    }),
    updateCompany: builder.mutation<ApiResponse<ISingleCompany>, UpdateCompanyPayload>({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
    }),
    createCompanyRelation: builder.mutation<ApiResponse<ISingleCompany>, CreateCompanyRelationPayload>({
      query: (payload) => ({
        url: `/${payload.id}/relations`,
        method: 'POST',
        body: payload,
      }),
    }),
    updateCompanyRelation: builder.mutation<ApiResponse<ISingleCompany>, UpdateCompanyRelationPayload>({
      query: (payload) => ({
        url: `/${payload.id}/relations/${payload.relation_id}`,
        method: 'PUT',
        body: payload,
      }),
    }),
    removeCompanyRelation: builder.mutation<ApiResponse<ISingleCompany>, RemoveCompanyRelationPayload>({
      query: (payload) => ({
        url: `/${payload.id}/relations/${payload.relation_id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useRemoveCompanyMutation,
  useLazyFetchCompaniesQuery,
  useCreateCompanyMutation,
  useUpdateCompanyMutation,
  useLazyGetCompanyQuery,
  useCreateCompanyRelationMutation,
  useUpdateCompanyRelationMutation,
  useRemoveCompanyRelationMutation,
} = companiesApi;
